import React, { useState } from "react";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { ApplicantDetails } from "../../interface/application";

import { useNotificationService } from "../notification";
import { apiGetMedicHistory } from "../../api/application";
import {
  PaginationDetails,
  PaginationDetailsDummyData,
} from "../../interface/api_request";
import { Pagination } from "../Pagination";

import MedicHistoryTable from "./MedicHistoryTable";

const MedicHistory = ({ medic_id }: { medic_id: string }) => {
  const { showNotification } = useNotificationService();
  const [filters, setFilters] = useState("");
  const [compare, setCompare] = useState(false); // Retained for future use in UI, though not used in fetch logic yet

  // set up pagination state
  const [pagination_state, setPagination_state] = useState<PaginationDetails>(
    PaginationDetailsDummyData,
  );

  // useQuery to fetch data
  const {
    data: queryData,
    isPending,
    isError,
    error,
  } = useQuery({
    // Query key includes all dependencies that should trigger a refetch
    queryKey: ["medicHistory"],
    queryFn: () => apiGetMedicHistory(medic_id),
    enabled: !!medic_id, // Only run the query if token and medic_id are available
  });

  // Effect to handle success and error side effects when queryData changes
  React.useEffect(() => {
    if (queryData) {
      // Handle error
      if (queryData?.status === "error") {
        if ("msg" in queryData) {
          showNotification(queryData?.msg ?? "", "error");
        }
        // Optionally reset pagination state or applicant list on error if needed
        return;
      }

      // Handle success
      if ("data" in queryData && queryData?.data) {
        if (!!queryData?.data?.meta) {
          setPagination_state({
            hasNextPage: queryData?.data?.meta?.hasNextPage,
            hasPrevPage: queryData?.data?.meta?.hasPrevPage,
            nextPage: queryData?.data?.meta?.nextPage,
            page: queryData?.data?.meta?.page,
            pages: queryData?.data?.meta?.pages,
            prevPage: queryData?.data?.meta?.prevPage,
            reads: queryData?.data?.meta?.reads,
            totalDocs: queryData?.data?.meta?.totalDocs,
            unReads: queryData?.data?.meta?.unReads,
          });
        }
      }
    }
  }, [queryData, showNotification]);
  console.log("Medic history data:", queryData);

  React.useEffect(() => {
    if (isError) {
      // Handle query-level error (e.g., network failure)
      showNotification("Process failed", "error");
      console.error("Query Error:", error);
    }
  }, [isError, error, showNotification]);

  // Extract the application list, defaulting to an empty array
  const applications_list: ApplicantDetails[] =
    queryData?.status === 200 && queryData?.data?.data
      ? queryData.data.data
      : [];

  return (
    <Box sx={{ padding: 2 }}>
      <MedicHistoryTable data={applications_list} loading={isPending} />

      {applications_list?.length > 5 && (
        <Pagination
          paginationState={pagination_state}
          setPaginationState={setPagination_state}
        />
      )}
    </Box>
  );
};

export default MedicHistory;
